import React from 'react';

import { Provider } from 'react-redux';

import Play from './Play';
import store from './redux/store';

// TODO: slug can be taken from page url
const PlayWrapper = ({ slug }: { readonly slug: string }) => (
    <Provider store={store}>
        <Play slug={slug} />
    </Provider>
);

export default PlayWrapper;
